"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _themeTools = require("@chakra-ui/theme-tools");

var breakpoints = (0, _themeTools.createBreakpoints)({
  sm: '375px',
  md: '640px',
  lg: '1024px',
  xl: '1440px'
});
var _default = breakpoints;
exports.default = _default;

//# sourceMappingURL=breakpoints.js.map